import { type Locale, GetLocationFromIdDocument } from '@/generated'
import { initializeApollo } from '@/lib/apollo/apolloClient'
import { sendToLogger } from '@/utils/sendToLogger'

/**
 * Get location name from location ID
 */
export const getLocationName = async (locationId: number): Promise<Locale> => {
  const client = initializeApollo()

  try {
    const { data } = await client.query({
      query: GetLocationFromIdDocument,
      variables: { locationId: locationId },
    })

    return data.location.name
  } catch (err) {
    sendToLogger(err)
    return { en_CA: '', fr_CA: '' }
  }
}
